import {useMemo} from 'react';
import {StaticImageData} from 'next/image';
import {useAssetPrefix} from 'mkt-ssr/lib/assets/HostDataProvider';

/**
 * Hook to generate asset URLs properly mapped to the CDN or SSR service for the
 * current environment.
 */
export function useAssetUrl(path: StaticImageData | {src: string} | string) {
  const assetPrefix = useAssetPrefix();

  return useMemo(() => {
    // Note that this path is generally handled by the webpack loader
    // and will be transformed to include the assetPath already.
    const filePath = typeof path === 'string' ? path : path.src;

    if (filePath.startsWith('http')) {
      return filePath;
    }

    return `${assetPrefix}${filePath}`;
  }, [assetPrefix, path]);
}
